import { getFromSessionStorage } from "./helper";
import { toast } from "sonner";

export const AuthProvider = ({ children }) => {
  const token = getFromSessionStorage("token");
  if (!token) {
    toast.error("Access Denied, login required");
    window.open("/login", "_self");
    return null;
  } else {
    return <div>{children}</div>;
  }
};
